import { GelTheme } from '@onegov/react-component-library';
import { Card, FormCheckbox } from '@snsw/react-component-library';
import { IconChevronDown } from '@snsw/react-component-library/build/Icons/system';
import React, { useEffect } from 'react';
import { useState } from 'react';
import FieldError from 'shared/components/fieldError';
import styled, { css } from 'styled-components/macro';

const CheckboxCardContainer = styled(Card)`
  height: auto;
  ${(props) =>
    props.hasError &&
    css`
      border: 2px solid rgb(184, 18, 55);
    `}
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
`;

const CheckboxTitle = styled(FormCheckbox)`
  display: flex;
  flex: 1 1 ${GelTheme.spacing(2)};
  label {
    font-size: 1.375rem;
    font-weight: 700;
    padding-left: 3.5rem;
    padding-bottom: 0;
    padding-top: 0;
  }
`;

const Chevron = styled.div`
  flex: 0 1 ${GelTheme.spacing(4)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: end;
  min-height: 2rem;

  svg {
    transition: transform 200ms ease-out;
  }

  ${(props) =>
    !props.collapsed &&
    css`
      svg {
        transform: rotate(-180deg);
      }
    `}
`;

export const ContentContainer = styled.div`
  padding-left: 3.5rem;
  display: flex;
  flex-direction: column;
`;

export const CheckboxCardRowContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const CheckboxCardContentTitle = styled.div`
  display: flex;
  flex: 0 0 auto;
  font-weight: 500;
`;

export const CheckboxCardContentValue = styled.div``;

export const CheckboxCard = ({
  id,
  title,
  expanded = false,
  onChange = () => {},
  isChecked = false,
  defaultContent = null,
  expandedContent = null,
  errorMessage = '',
  hasError = false,
}) => {
  const [collapsed, setCollapsed] = useState(!expanded);
  const handleToggleCollapsed = () => setCollapsed((prev) => !prev);

  useEffect(() => {
    setCollapsed(!expanded);
  }, [expanded]);

  return (
    <>
      <CheckboxCardContainer id={id} hasError={hasError}>
        <TitleContainer>
          {title && (
            <CheckboxTitle
              id={`${id}_checkbox`}
              label={title}
              onChange={onChange}
              checked={isChecked}
              name={id}
              value={id}
            />
          )}
          <Chevron collapsed={collapsed} onClick={handleToggleCollapsed}>
            <IconChevronDown aria-label="Toggle content" aria-expanded={!collapsed} aria-controls={id} />
          </Chevron>
        </TitleContainer>
        {defaultContent && <ContentContainer>{defaultContent}</ContentContainer>}
        {!collapsed && expandedContent && <ContentContainer>{expandedContent}</ContentContainer>}
      </CheckboxCardContainer>

      {hasError && errorMessage && <FieldError message={errorMessage} marginBottom="2rem" />}
    </>
  );
};

export const RowContent = ({ label, value }) => {
  return (
    <CheckboxCardRowContentContainer>
      {label && <CheckboxCardContentTitle>{label}:</CheckboxCardContentTitle>}
      <CheckboxCardContentValue>{value}</CheckboxCardContentValue>
    </CheckboxCardRowContentContainer>
  );
};
